import $ from 'jquery';

$(() => {
  $('.btn-quote').on('click', () => {
    $('a[role="tab"][href="#quote"]').tab('show');
  });
});
